export default __webpack_public_path__ + "static/media/event-action-delay.8da31f9f.svg";